import { useCallback, useEffect, useState } from "react";
import { Box, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody, Grid, TextField, Button } from "@mui/material";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import { fetchTrialBalance } from "../../../services/accounting";

export default function TrialBalancePage() {
  useProtectedRoute();
  const { token } = useAuth();
  const [from, setFrom] = useState<string>(new Date(new Date().getFullYear(), 0, 1).toISOString().slice(0,10));
  const [to, setTo] = useState<string>(new Date().toISOString().slice(0,10));
  const [accounts, setAccounts] = useState<Record<string, { debit: number; credit: number }>>({});

  const load = useCallback(async () => {
    try {
      const res = await fetchTrialBalance(token!, { from, to });
      setAccounts(res.accounts || {});
    } catch (e) { console.error(e); }
  }, [token, from, to]);

  useEffect(() => { if (token) load(); }, [token, load]);

  const totals = Object.values(accounts).reduce((s, a) => ({ debit: s.debit + a.debit, credit: s.credit + a.credit }), { debit: 0, credit: 0 });

  return (
    <Box p={4}>
      <Typography variant="h5" fontWeight="bold" className="mb-4">Trial Balance</Typography>
      <Grid container spacing={2} className="mb-3">
        <Grid item xs={12} sm={4}><TextField fullWidth type="date" label="From" value={from} onChange={e=>setFrom(e.target.value)} InputLabelProps={{ shrink: true }} /></Grid>
        <Grid item xs={12} sm={4}><TextField fullWidth type="date" label="To" value={to} onChange={e=>setTo(e.target.value)} InputLabelProps={{ shrink: true }} /></Grid>
        <Grid item xs={12} sm={4}><Button fullWidth variant="contained" onClick={load}>Run</Button></Grid>
      </Grid>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Account</TableCell>
              <TableCell align="right">Debit</TableCell>
              <TableCell align="right">Credit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(accounts).map(([acc, v]) => (
              <TableRow key={acc}>
                <TableCell>{acc}</TableCell>
                <TableCell align="right">{Number(v.debit).toFixed(2)}</TableCell>
                <TableCell align="right">{Number(v.credit).toFixed(2)}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell><strong>Totals</strong></TableCell>
              <TableCell align="right"><strong>{totals.debit.toFixed(2)}</strong></TableCell>
              <TableCell align="right"><strong>{totals.credit.toFixed(2)}</strong></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
